import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';
import { initialState, reducer } from './reducers';
import { api } from './api/api';
import { setupListeners } from '@reduxjs/toolkit/query';
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

let sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

export const setupStore = (preloadedState = {}) => {
    return configureStore({
        reducer: reducer,
        middleware: (getDefaultMiddleware) => {
            // Use a type assertion to tell TypeScript these are compatible middleware types
            return getDefaultMiddleware({
                serializableCheck: false,
            }).concat(middleware, api.middleware as any);
        },
        devTools: true,
        preloadedState,
    });
};

export const store = setupStore(initialState);

export const runSagaMiddleware = () => {
    sagaMiddleware.run(rootSaga);
};

runSagaMiddleware();

// Required for RTK Query's refetchOnFocus/refetchOnReconnect
setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
